(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paaro-couture-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('paaro-product')) customElements.define('paaro-product', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.hydrateDescription();
    this.initWishlist();
    this.addEventListener('click', e => this.clickHandler(e), {signal:this.abort.signal});
    this.addEventListener('change', e => {if(e.target.matches('[data-option]')) this.changeVariant(e.target);}, {signal:this.abort.signal});
    this.addEventListener('pointermove', e => {
      const button=e.target.closest('[data-zoom]');
      const panel=this.querySelector('.pp-zoom-panel');
      if(!button || panel.hidden) return;
      const box=button.getBoundingClientRect();
      panel.style.backgroundPosition=`${Math.max(0,Math.min(100,(e.clientX-box.left)/box.width*100))}% ${Math.max(0,Math.min(100,(e.clientY-box.top)/box.height*100))}%`;
    }, {signal:this.abort.signal});
    this.addEventListener('keydown', e=>{if(e.key==='Escape') this.querySelector('.pp-zoom-panel').hidden=true;}, {signal:this.abort.signal});
  }
  hydrateDescription(){
    const source=this.querySelector('[data-description-source]');
    const description=this.querySelector('[data-description-target]');
    const shipping=this.querySelector('[data-shipping-target]');
    if(!source)return;
    const normalize=value=>value.trim().toLowerCase();
    const descriptionHeading=normalize(this.dataset.descriptionHeading||'Product Description');
    const shippingHeading=normalize(this.dataset.shippingHeading||'Shipping Information');
    const buckets={description:[],shipping:[]};
    let bucket='description';
    [...source.children].forEach(node=>{
      if(node.tagName==='H3'){
        const heading=normalize(node.textContent);
        if(heading===descriptionHeading){bucket='description';return;}
        if(heading===shippingHeading){bucket='shipping';return;}
      }
      buckets[bucket].push(node.outerHTML);
    });
    if(description)description.innerHTML=buckets.description.join('')||source.innerHTML;
    if(shipping&&buckets.shipping.length)shipping.innerHTML=buckets.shipping.join('');
  }
  initWishlist(){
    const custom=this.querySelector('.wishlist-hero-custom-button');
    const target=this.querySelector('#wishlist-hero-product-page-button');
    if(!custom)return;
    let tries=0;
    this.wishlistTimer=setInterval(()=>{
      tries+=1;
      if(target?.children.length){clearInterval(this.wishlistTimer);return;}
      const sdk=window.WishListHero_SDK;
      if(sdk?.InitializeAddToWishListButton){
        sdk.InitializeAddToWishListButton({ButtonClassElement:[...custom.classList].find(name=>name.startsWith('wishlisthero-floating-')),ProductId:custom.dataset.wlhId,ProductLink:custom.dataset.wlhLink,ProductVariantId:custom.dataset.wlhVariantid,ProductPrice:Number(custom.dataset.wlhPrice),ProductTitle:custom.dataset.wlhName,ProductImage:custom.dataset.wlhImage,ButtonMode:'icon_only',WishlistHash:'Product'});
        clearInterval(this.wishlistTimer);
      }else if(tries>=20)clearInterval(this.wishlistTimer);
    },250);
  }
  disconnectedCallback(){this.abort?.abort();this.request?.abort();clearInterval(this.wishlistTimer);}
  clickHandler(e){
    const thumb=e.target.closest('[data-media]');
    if(thumb){
      this.querySelectorAll('[data-panel]').forEach(p=>{p.hidden=p.dataset.panel!==thumb.dataset.media;p.querySelectorAll('video').forEach(v=>v.pause());});
      this.querySelectorAll('[data-media]').forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));
      this.querySelector('.pp-zoom-panel').hidden=true;
    }
    const zoom=e.target.closest('[data-zoom]');
    if(zoom){
      if(matchMedia('(min-width:990px) and (pointer:fine)').matches){const panel=this.querySelector('.pp-zoom-panel');panel.hidden=!panel.hidden;panel.style.backgroundImage=`url("${zoom.dataset.zoom}")`;panel.style.backgroundPosition='50% 50%';}
      else{const dialog=this.querySelector('.pp-image-dialog');const image=new Image();image.src=zoom.dataset.zoom;image.alt=zoom.querySelector('img').alt;dialog.querySelector('.pp-full-image').replaceChildren(image);dialog.showModal();}
    }
    if(e.target.closest('[data-zoom-close]')){this.querySelector('.pp-zoom-panel').hidden=true;this.querySelector('[data-panel]:not([hidden]) [data-zoom]')?.focus();}
    if(e.target.closest('[data-size-open]'))this.querySelector('.pp-size-dialog').showModal();
    if(e.target.closest('[data-dialog-close]'))e.target.closest('dialog').close();
    if(e.target.closest('[data-buy-now]'))this.buyNow(e.target.closest('[data-buy-now]'));
  }
  async buyNow(button){
    const form=this.querySelector('.pp-form');
    const status=this.querySelector('.pp-status');
    button.disabled=true;
    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const result=await response.json();
      if(!response.ok)throw Error(result.description||this.dataset.error);
      window.location.assign(`${window.Shopify?.routes?.root||'/'}checkout`);
    }catch(error){status.textContent=error.message||this.dataset.error;button.disabled=false;}
  }
  async changeVariant(input){
    this.request?.abort();this.request=new AbortController();
    const values=[...this.querySelectorAll('[data-option]:checked')].map(x=>x.value);
    const url=new URL(input.dataset.productUrl||this.dataset.url,location.origin);
    url.searchParams.set('option_values',values.join(','));url.searchParams.set('section_id',this.dataset.section);
    this.querySelectorAll('.shopify-payment-button').forEach(button=>button.hidden=true);
    const addButton=this.querySelector('.pp-add');if(addButton)addButton.disabled=true;this.querySelector('[name="id"]').disabled=true;
    this.querySelector('.pp-info').setAttribute('aria-busy','true');
    try{
      const response=await fetch(url,{signal:this.request.signal});if(!response.ok)throw Error('request');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const next=[...html.querySelectorAll('paaro-product')].find(x=>x.dataset.section===this.dataset.section);if(!next)throw Error('section');
      const focusedValue=input.value;
      this.replaceWith(next);
      next.querySelector(`[data-option][value="${focusedValue}"]`)?.focus({preventScroll:true});
      url.searchParams.delete('section_id');if(next.dataset.variant){url.searchParams.delete('option_values');url.searchParams.set('variant',next.dataset.variant);}
      history.replaceState({},'',url);
    }catch(error){if(error.name!=='AbortError'){this.querySelector('.pp-status').textContent=this.dataset.error;this.querySelector('.pp-info').removeAttribute('aria-busy');}}
  }
});

  } catch(e) { console.error(e); }
})();
})();
